<template>
  <section class="page">
    <div class="card">
      <h1>Login</h1>
      <form>
        <input type="text" ref="email" v-model="email" placeholder="Email">
        <input type="password" v-model="password" placeholder="Password">
        <div class="button-group">
          <Button v-bind:title="'Log In'" v-bind:type="'raised'" v-bind:colorTheme="'primary'" v-on:button-click="signInWithPassword" />
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Button from '@/components/form-elements/Button';

export default {
  name: 'Login',
  components: { Button },
  data() {
    return { email: '', password: '' }
  },
  mounted() {
    this.$refs.email.focus()
  },
  methods: {
    signInWithPassword() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(() => this.$router.replace('projects'))
        .catch((error) => {
          alert(error.code)
          alert(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';
@import '../assets/styles/card';
@import '../assets/styles/input';
</style>



// WEBPACK FOOTER //
// src/components/Login.vue